var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPptExpHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 0.89543 3.89543 0 5 0H15L18 3L21 6V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#FAFCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V20Z",
    fill: "#F57037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H21L15 0V6Z",
    fill: "#D7E3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15853 12.7249V10.9799H7.07708C7.73082 10.9799 8.02046 11.3066 8.02046 11.8567C8.02046 12.3897 7.73082 12.7249 7.07708 12.7249H6.15853ZM9.21209 11.8567C9.21209 10.8166 8.51697 10 7.12673 10H5V16H6.15853V13.6963H7.12673C8.61627 13.6963 9.21209 12.7679 9.21209 11.8567Z",
    fill: "#F57037"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1932 12.7249V10.9799H12.1117C12.7655 10.9799 13.0551 11.3066 13.0551 11.8567C13.0551 12.3897 12.7655 12.7249 12.1117 12.7249H11.1932ZM14.2467 11.8567C14.2467 10.8166 13.5516 10 12.1614 10H10.0346V16H11.1932V13.6963H12.1614C13.6509 13.6963 14.2467 12.7679 14.2467 11.8567Z",
    fill: "#F57037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7631 10.9713H16.3023V16H17.4608V10.9713H19V10H14.7631V10.9713Z",
    fill: "#F57037"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptExpHover);
export default __webpack_public_path__ + "static/media/PPT Exp Hover.642277aab4a8eae6547dd1e7863f65e4.svg";
export { ForwardRef as ReactComponent };